export const isIe = () => {
	const ua = window.navigator.userAgent;
	return /MSIE|Trident/.test(ua);
};
